import { MifeParcel } from '@/components/MifeParcel';
import { useAuth } from '@/features/auth/store/authStore';
import { eventBus } from '@/libs/eventBus';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/_unauthenticated/(auth-routes)/login')({
  component: Login,
});

function Login() {
  const search = Route.useSearch();
  const signIn = useAuth.use.signIn();
  const navigate = useNavigate();

  useEffect(() => {
    // TT-289: same function for on and off, so the handler is removed on unmount
    const handleLogin = (event: { IdToken: string; redirectTo?: string }) => {
      signIn(event.IdToken);
      navigate({ to: event.redirectTo ?? search.to });
    };

    eventBus.on('mife:login', handleLogin);

    return () => eventBus.off('mife:login', handleLogin);
  }, [navigate, search.to, signIn]);

  return <MifeParcel />;
}
